<template>
    <div class="card col-md-8 mx-auto px-0">
        <div class="card-header bg-primary text-white">
            <div class="card-title h5 m-0">{{ $t('person.moodleAccountDetails') }}</div>
        </div>
        <div class="card-body">
            <div class="form-row">
                <div class="col-md-8 col-sm-12">
                    <div class="form-group row">
                        <label for="moodleAccountLink" class="col-sm-12 col-md-6 font-weight-bold">{{ $t('person.moodleAccountLinkLabel') }}:</label>
                        <div class="col-sm-12 col-md-6" v-if="model.moodleUserAccountDetails.userSyncedWithMoodle">
                            <a target="_blank" :href="model.moodleUserAccountDetails.moodleAccountLink">{{ model.moodleUserAccountDetails.moodleAccountLink }}</a>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="moodleAccountLink" class="col-sm-12 col-md-6 font-weight-bold">{{ $t('person.accountSyncedWithMoodle') }}:</label>
                        <div class="col-sm-12 col-md-6">
                            <span :class="model.moodleUserAccountDetails.userSyncedWithMoodle ? 'badge badge-success' : 'badge badge-warning'">
                                {{ model.moodleUserAccountDetails.userSyncedWithMoodle ? $t('yes') : $t('no') }}</span>
                        </div>
                    </div>
                    <div v-if="!model.moodleUserAccountDetails.userSyncedWithMoodle && !model.moodleUserAccountDetails.userExistingInMoodleButNotSynced">
                        <div v-if="personModel">
                            <button class="ml-0 btn btn-outline-info"
                                    @click.stop="createAccountInMoodle"
                                    :disabled="sync">
                                <i class="fas fa-spinner fa-spin" v-if="sync"></i>
                                <i class="fas fa-sync" v-else></i>
                                {{ $t('buttons.createUserAccountInMoodle.btnText') }}
                            </button>
                            <div class="alert alert-info" role="alert">
                                <h6>{{ $t('person.createMoodleAccountHelp') }}</h6>
                            </div>
                        </div>
                        <div v-else>
                            <div class="alert alert-warning" role="alert">
                                <h6>{{ $t('person.missingPersonAlert') }}</h6>
                            </div>
                        </div>
                    </div>
                    <div v-if="model.moodleUserAccountDetails.userExistingInMoodleButNotSynced">
                        <div v-if="personModel">
                            <button class="ml-0 btn btn-outline-info"
                                    @click.stop="syncAccountWithMoodle"
                                    :disabled="sync">
                                <i class="fas fa-spinner fa-spin" v-if="sync"></i>
                                <i class="fas fa-sync" v-else></i>
                                {{ $t('buttons.syncWithMoodle.btnText')}}
                            </button>
                        </div>
                        <div v-else>
                            <div class="alert alert-warning" role="alert">
                                <h6>{{ $t('person.missingPersonAlert') }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <label class="font-weight-bold" :for="'moodleSyncResult' + _uid">{{ $t('person.moodleAccountSyncResult') }}</label>
                    <textarea rows="5"
                            class="form-control"
                            v-if="model.moodleUserAccountDetails.userSyncedWithMoodle"
                            v-model="model.moodleUserAccountDetails.moodleAccountSyncDetails"
                            :readonly="true"
                            :name="'moodleSyncResult' + _uid"
                            :id="'moodleSyncResult' + _uid"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { AspNetUser, Person, MoodleUserCreateModel } from '@/models/models';
    import personService from '@/services/person.service';
    import userService from '@/services/user.service';

    export default {
        props: {
            value: {
                type: AspNetUser,
                required: false
            },
        },
        data() {
            return {
                sync: false,
                personModel: null,
                model: this.value
            }
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new AspNetUser(this.value);
                }
            }
        },
        mounted() {
            this.loadCurrentUserPerson(this.model.id);
        },
        methods: {
            createAccountInMoodle() {
                this.sync = true;
                const model = new MoodleUserCreateModel(
                    {
                        idnumber: this.model.id,
                        userName: this.model.email,
                        email: this.model.email,
                        firstName: this.personModel.firstName,
                        lastName: this.personModel.lastName,
                        middleName: this.personModel.middleName,
                        description: this.personModel.description,
                        createpassword: 1
                    });

                this.$http
                    .post('/api/moodle/CreateUserFromIsupo', model)
                    .then(response => {
                        this.successCallback(response);
                    })
                    .catch(error => {
                        this.errorCallback(error);
                    }).then(() => { this.sync = false });
            },
            syncAccountWithMoodle() {
                this.sync = true;
                const model = new MoodleUserCreateModel(
                    {
                        idnumber: this.model.id,
                        userName: this.model.email,
                        email: this.model.email,
                        firstName: this.personModel.firstName,
                        lastName: this.personModel.lastName,
                        middleName: this.personModel.middleName,
                        description: this.personModel.description,
                        createpassword: 1
                    });

                this.$http
                    .post('/api/moodle/SyncUserFromIsupo', model)
                    .then(response => {
                        this.successCallback(response);
                    })
                    .catch(error => {
                        this.errorCallback(error);
                    }).then(() => { this.sync = false });
            },
            getUserById() {
                userService
                    .getById(this.model.id)
                    .then(response => {
                        let responseData = response.data;
                        if (responseData) {
                            this.model = responseData;
                        } else {
                            this.model = null;
                        }
                    })
                    .catch(error => {
                        this.model = null;
                        this.errorCallback(error);
                    });
            },
            loadCurrentUserPerson(id) {
                this.personLoading = true;
                personService
                    .getByUserId(id)
                    .then(response => {
                        let responseData = response.data;
                        if (responseData) {
                            this.personModel = new Person(responseData);
                        } else {
                            this.personModel = null;
                        }
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.errorCallback(error);
                    });
            },
            successCallback(response) {
                this.getUserById();
                    this.$vs.notify({
                        title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                        text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    })
            },
            errorCallback(error) {
                this.$vs.notify({
                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                    text: this.$helpers.errorText(error),
                    color: this.$helpers.errorColor(error),
                    time: this.$store.getters.notificationDuration
                })
            }
        }
    }
</script>
